import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import { MouseEvent, useState } from 'react'
import Box from '@mui/material/Box'
import { USAGE_STATUS, UsageStatusReason } from '../../model/types/Instance'
import { getUsageStatusReasonMessage } from '../../model/lib/getIsageStatusReasons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'

const icons: Record<USAGE_STATUS, any> = {
	'Likely unused': <FontAwesomeIcon icon={faClock} color="#E62A33" />,
	'Possibly unused': <FontAwesomeIcon icon={faClock} color="#FE9A00" />
}

interface Props {
	usageStatus: USAGE_STATUS
	usageStatusReasons: UsageStatusReason[]
	usageStatusContext: Record<string, string>
}

export const UsageStatusPopover = (props: Props) => {
	const {
		usageStatus,
		usageStatusReasons,
		usageStatusContext
	} = props

	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

	const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handlePopoverClose = () => {
		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)

	return (
		<div>
			<Typography
				aria-owns={open ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handlePopoverOpen}
				onMouseLeave={handlePopoverClose}
			>
				{icons[usageStatus]}
			</Typography>
			<Popover
				id="mouse-over-popover"
				sx={{ pointerEvents: 'none' }}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
			>
				<Box sx={{ p: 2, maxWidth: '240px' }}>
					<Box sx={{ display: 'flex', gap: 1 }}>
						{icons[usageStatus]}
						<Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
							{usageStatus}
						</Typography>
					</Box>
					{
						usageStatusReasons.length > 1 ? (
							<ul>
								{usageStatusReasons.map(reason => (
									<li>
										<StatusReason
											reason={reason}
											productVersion={usageStatusContext?.productVersion}
											maxProductVersion={usageStatusContext?.maxProductVersion}
										/>
									</li>

								))}
							</ul>
						) : (
							<StatusReason
								reason={usageStatusReasons[0]}
								productVersion={usageStatusContext?.productVersion}
								maxProductVersion={usageStatusContext?.maxProductVersion}
							/>
						)
					}
				</Box>
			</Popover>
		</div>
	)
}

function StatusReason({ reason, productVersion, maxProductVersion }: {
	reason: UsageStatusReason,
	productVersion?: string,
	maxProductVersion?: string
}) {
	const reasonMsg = getUsageStatusReasonMessage(reason, productVersion, maxProductVersion)
	return (
		<Typography sx={{ fontSize: '12px' }}>
			{reasonMsg}
		</Typography>
	)
}

